/*
 * @Author: Yandong Hu
 * @github: https://github.com/Mad-hu
 * @Date: 2022-03-21 11:23:58
 * @LastEditTime: 2022-03-22 10:11:51
 * @LastEditors: Yandong Hu
 * @Description: 另存为更改项目名称对话框
 */

import { Input, Modal } from "antd";
import React from "react";
import { useState } from "react";
import { useRecoilState } from "recoil";
import { DEFAULT_EXPORT_NAME } from "../../services/config.service";
import DialogService from "../../services/dialog.service";
import headerService from "../../services/header.service";
import mblockService from "../../services/mblock.service";
import "./dialog.scss";
export const DialogRename = () => {
  let inputText = "";
  const [getDialogRenameBoxVisibleState, setDialogRenameBoxVisibleState] =
    useRecoilState(DialogService.DialogRenameBoxVisibleState);
  const [getHeaderTextState, setHeaderTextState] = useRecoilState(
    headerService.HeaderTextState
  );

  const [confirmLoading, setConfirmLoading] = useState(false);

  const onCancel = () => {
    setConfirmLoading(false);
    setDialogRenameBoxVisibleState(false);
  };
  const onOk = () => {
    setConfirmLoading(true);
    const saveName =
      inputText === ""
        ? getHeaderTextState === ""
          ? DEFAULT_EXPORT_NAME
          : getHeaderTextState
        : inputText;
    setHeaderTextState(saveName);
    mblockService.doExport(`${saveName}`);
    setConfirmLoading(false);
    setDialogRenameBoxVisibleState(false);
  };
  const onInputChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    inputText = e.target.value;
  };

  return (
    <Modal
      title="另存为"
      visible={getDialogRenameBoxVisibleState}
      onOk={onOk}
      okText="保存"
      cancelText="取消"
      confirmLoading={confirmLoading}
      onCancel={onCancel}
    >
      <div className="dig" key={getHeaderTextState}>
        <div className="t">
          <span>保存名称：</span>
        </div>
        <Input
          placeholder="请输入项目名称"
          defaultValue={getHeaderTextState}
          onChange={onInputChange}
        />
      </div>
    </Modal>
  );
};
